module.exports = __webpack_public_path__ + "static/media/viber.a1cfec9b.png";